export default "__VITE_ASSET__xQ6yAUXk__"